import {Accordion, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	border: none;
	border-radius: 0 0 8px 8px;
	box-shadow: none;
	margin: 0;
	padding: 8px 16px;

	&::before {
		display: none;
	}

	&:not(:first-of-type) {
		border-top: 1px solid ${({theme}) => theme.palette.divider};
	}

	.MuiAccordionSummary-root {
		min-height: auto;
		gap: 8px;
		padding: 0;
	}

	.MuiAccordionSummary-root > div.MuiAccordionSummary-content {
		margin: 0;
	}
`;

export default StyledAccordion;
